import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Apple, Carrot, Beef, Fish, CupSoda, Wheat, Sparkles, Baby, Tag, Heart, ShoppingBag, Settings, X, Repeat, Snowflake, CakeSlice, Cookie, FlaskConical, Package, ScrollText, HomeIcon, Milk } from 'lucide-react';
import axios from 'axios';

const API = window.location.origin + '/api';

const iconMap = {
  'tag': Tag, 'apple': Apple, 'carrot': Carrot, 'beef': Beef,
  'fish': Fish, 'cup-soda': CupSoda, 'wheat': Wheat,
  'sparkles': Sparkles, 'baby': Baby, 'milk': Milk,
  'snowflake': Snowflake, 'cake-slice': CakeSlice, 'cookie': Cookie,
  'flask-conical': FlaskConical, 'package': Package, 'scroll': ScrollText,
  'home': HomeIcon
};

export default function SideMenu({ isOpen, onClose }) {
  const [categories, setCategories] = useState([]);
  const location = useLocation();

  useEffect(() => {
    axios.get(`${API}/categories`).then(r => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => { onClose(); }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className={`side-menu-overlay ${isOpen ? 'open' : ''}`} onClick={onClose} data-testid="side-menu-overlay" />
      <nav className={`side-menu ${isOpen ? 'open' : ''}`} data-testid="side-menu">
        <div className="side-menu-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="https://customer-assets.emergentagent.com/job_quick-groceries-71/artifacts/wofxcf6m_ChatGPT%20Image%20May%2021%2C%202026%2C%2002_34_32%20PM.png" alt="Logo" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />
              <h2><span style={{ color: '#FF9E11' }}>Store</span><span style={{ color: '#31C4E8' }}>Runs</span></h2>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }} data-testid="close-menu-btn">
              <X size={22} />
            </button>
          </div>
          <p>We Shop, We Deliver, You Relax</p>
        </div>
        <div className="side-menu-nav">
          <Link to="/" data-testid="nav-home">
            <Home size={20} />
            Home
          </Link>
          <div className="side-menu-divider" />
          {categories.map(cat => {
            const Icon = iconMap[cat.icon] || Tag;
            return (
              <Link key={cat.slug} to={`/category/${cat.slug}`} data-testid={`nav-${cat.slug}`}>
                <Icon size={20} />
                {cat.name}
              </Link>
            );
          })}
          <div className="side-menu-divider" />
          <Link to="/wishlist" data-testid="nav-wishlist">
            <Heart size={20} />
            Wishlist
          </Link>
          <Link to="/orders" data-testid="nav-orders">
            <ShoppingBag size={20} />
            My Orders
          </Link>
          <Link to="/subscriptions" data-testid="nav-subscriptions">
            <Repeat size={20} />
            Recurring Orders
          </Link>
        </div>
      </nav>
    </>
  );
}
